$shm_projects_goal_chat $shm_codex_app
	run? null
	iteration 0
	prerelease false
	version \
	workspace_id \base
	clarifications /
	after /
	After $mol_view
		sub <= after /
	Process_view $mol_view
		sub /
			<= Process_messages $mol_view
				sub <= message_rows /
	Message* $mol_card
		theme <= message_theme* \
		attr *
			^
			role <= message_role_key* \
		sub /
			<= Message_head* $mol_view
				sub /
					<= Message_role* $mol_paragraph
						title <= message_role* \
					<= Message_thinking* $mol_link
						arg <= reasoning_arg* *
						sub /
							<= Message_thinking_icon* $mol_icon_eye
							<= message_thinking_title* \
						click? <=> reasoning_select*? null
					<= Message_time* $mol_paragraph
						title <= message_time* \
			<= Message_text_box* $mol_view
				sub /
					<= Message_images* $shm_projects_image_viewer
						content /
							<= Message_text* $shm_agent_message_text
								text <= message_text* \
	Thinking $shm_projects_goal_thinking
		entries <= thinking_entries /
		close? <=> thinking_close? null
	pages /
		<= Chat_page
